import { Languages } from "src/common/descriptions/types";
import { CreateUserDescriptions } from "./types";

const DescriptionsEnUs: CreateUserDescriptions = {
    EDIT_TITLE: "Edit User",
    TITLE: "Create User",
    SAVE_BUTTON: "Save",
    CANCEL_BUTTON: "Cancel",
    CONFIRM_MODAL: {
        TITLE: 'Save User?',
        DESCRIPTION: "Operation will not be reverted.",
        ACTION_BUTTON: "Save",
        CANCEL_BUTTON: "Go Back",
    },
    CANCEL_MODAL: {
        TITLE: "Cancel User input?",
        DESCRIPTION: "All data will be lost.",
        ACTION_BUTTON: "Yes, Cancel",
        CANCEL_BUTTON: "Keep working",
    },
    SUCCESS_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "User Created",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Success",
        PRIMARY_LABEL: "Accept",
        SECONDARY_LABEL: "Accept",
        DESCRIPTION: "User Updated",
    },
    FORM: {
        NAME: {
            LABEL: "Name",
            PLACEHOLDER: "Input Name",
        },
        SURNAME: {
            LABEL: "Surname",
            PLACEHOLDER: "Input Surname",
        },
        USERNAME: {
            LABEL: "Username",
            PLACEHOLDER: "Input Username",
        },
        STATUS: {
            LABEL: "Status",
            PLACEHOLDER: "Select status",
        },
        ROLE: {
            LABEL: "Role",
            PLACEHOLDER: "Select Role",
        },
        PASSWORD: {
            LABEL: "Password",
            PLACEHOLDER: "Input password",
        },
        PASSWORD_CONFIRM: {
            LABEL: "Confirm Password",
            PLACEHOLDER: "Confirm password",
        },
        OLD_PASSWORD: {
            LABEL: "Old Passowrd",
            PLACEHOLDER: "Old Password",
        },
    },
    MAIN_ACTION_TITLE: "Creating User",
    MAIN_ACTION_DESCRIPTION: "Please wait...",
    ERROR_PASSWORDS_MISSMATCH: "Passwords don't match",
    ERROR_USERNAME_ALREADY_USED: "Username is already in use, please select a differente one",
    PASSWORD_UPDATE_ERROR_TITLE: "Error",
    PASSWORD_UPDATE_SUCCESS_TITLE: "Success",
    PASSWORD_UPDATE_SUCCESS_DESCRIPTION: "User password has been updated",
    MORE_OPTIONS: {
        TITLE: "More",
        ASSIGN_NEW_PASSWORD: "Assign new password",
        RESET_PASSWORD: "Reset password",
        PASSWORD_ASSIGN_DESCRIPTION: "Password will be assigned to user",
    },
}

const DescriptionsEsUs: CreateUserDescriptions = {
    EDIT_TITLE: "Editar Usuario",
    TITLE: "Crear Usuario",
    SAVE_BUTTON: "Guardar",
    CANCEL_BUTTON: "Cancelar",
    CONFIRM_MODAL: {
        TITLE: 'Guardar Usuario con los datos ingresados?',
        DESCRIPTION: "La operación no podrá ser revertida.",
        ACTION_BUTTON: "Guardar",
        CANCEL_BUTTON: "Regresar",
    },
    CANCEL_MODAL: {
        TITLE: "Cancelar ingreso de Usuario?",
        DESCRIPTION: "La información ingresada sera borrada.",
        ACTION_BUTTON: "Si, Cancelar",
        CANCEL_BUTTON: "Seguir ingresando",
    },
    SUCCESS_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Usuario creado",
    },
    SUCCESS_SECONDARY_MODAL: {
        TITLE: "Exito",
        PRIMARY_LABEL: "Aceptar",
        SECONDARY_LABEL: "Aceptar",
        DESCRIPTION: "Usuario Actualizado",
    },
    FORM: {
        NAME: {
            LABEL: "Nombre",
            PLACEHOLDER: "Ingresa nombre",
        },
        SURNAME: {
            LABEL: "Apellidos",
            PLACEHOLDER: "Ingresa apellidos",
        },
        USERNAME: {
            LABEL: "Usuario",
            PLACEHOLDER: "Ingresa usuario",
        },
        STATUS: {
            LABEL: "Estado",
            PLACEHOLDER: "Selecciona",
        },
        ROLE: {
            LABEL: "Rol",
            PLACEHOLDER: "Selecciona",
        },
        PASSWORD: {
            LABEL: "Contraseña",
            PLACEHOLDER: "Ingrese contraseña",
        },
        PASSWORD_CONFIRM: {
            LABEL: "Confirmar Contraseña",
            PLACEHOLDER: "Confirmar contraseña",
        },
        OLD_PASSWORD: {
            LABEL: "Contraseña Anterior",
            PLACEHOLDER: "Cotraseña anterior",
        },
    },
    MAIN_ACTION_TITLE: "Creando Usuario",
    MAIN_ACTION_DESCRIPTION: "Por favor espere...",
    ERROR_PASSWORDS_MISSMATCH: "Las contraseñas no coinciden",
    ERROR_USERNAME_ALREADY_USED: "El usuario ingresado ya se encuentra en uso, usa otro diferente",
    PASSWORD_UPDATE_ERROR_TITLE: "Error",
    PASSWORD_UPDATE_SUCCESS_TITLE: "Éxito",
    PASSWORD_UPDATE_SUCCESS_DESCRIPTION: "La contraseña ha sido actualizada",
    MORE_OPTIONS: {
        TITLE: "Más",
        ASSIGN_NEW_PASSWORD: "Asignar nueva contraseña",
        RESET_PASSWORD: "Reiniciar contraseña",
        PASSWORD_ASSIGN_DESCRIPTION: "Se asignará la contraseña al usuario",
    },
}

export const createUserDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}